// extracted by mini-css-extract-plugin
export var articleWrapper = "k_n1";
export var articleText = "k_n2 d_dt d_cr";
export var header = "k_n3 d_Y d_v";
export var headerImageWrapper = "k_n4 d_bc d_Z d_7 d_6 d_3 d_8 d_bj d_bQ";
export var headerGradient = "k_n5 d_bc d_Z d_7 d_6 d_3 d_8";
export var headerGradientOverlay = "k_n6 d_bc d_Z d_7 d_6 d_3 d_8";
export var headerContentWrapper = "k_n7 d_by d_bN d_bC d_bH d_bk d_Y";
export var headerContentWrapperAlt = "k_n8 d_by d_bN d_bC d_bH d_bk d_Y";
export var contentWrapper = "k_n9 d_v";
export var dateTag = "k_pb d_cd d_cq d_dp d_v";
export var icon1 = "k_pc d_cN";
export var icon2 = "k_pd d_cN d_cH";
export var tagBtn = "k_pf d_b0 d_cC d_dn d_dz";
export var headerText = "k_pg d_v d_cd d_cr d_bV";
export var center = "k_ph d_dv";
export var videoIframeStyle = "k_pj d_d4 d_v d_G d_bx d_b0 d_Q";
export var articleImageWrapper = "k_pk d_cr d_Y";
export var articleImageWrapperIcon = "k_pl d_cr d_Y";
export var articleRow = "k_pm d_bC";
export var quoteWrapper = "k_gP d_bB d_bN d_cr";
export var quoteBar = "k_pn d_G";
export var quoteText = "k_pp";
export var authorBox = "k_pq d_v";
export var authorRow = "k_pr d_bC d_bV d_cx";
export var separator = "k_ps d_v";
export var line = "k_fj d_v d_fj d_cX d_cx";
export var authorImage = "k_ln d_b6 d_Y d_v d_cs";
export var authorText = "k_pt d_cg d_cs";
export var masonryImageWrapper = "k_pv";
export var bottomSeparator = "k_pw d_v d_cx";
export var linksWrapper = "k_px d_cg d_dt";
export var comments = "k_py d_bC d_cx";
export var sharing = "k_pz d_by d_bC d_bH";
export var shareText = "k_pB d_v d_dv";
export var icon = "k_pC";
export var customRow = "k_pD d_bC d_Y";
export var text = "k_pF";
export var SubtitleSmall = "k_pG";
export var SubtitleNormal = "k_pH";
export var SubtitleLarge = "k_pJ";